export default function AnalysisSection() {
  const analyses = [
    {
      title: "26/01/2026 Football Analysis English Championship Norwich City VS Coventry",
      image: "https://www.zeankickoff1.com/images/logo2/ENGLISH LEAGUE CHAMPIONSHIP.jpg"
    },
    {
      title: "26/01/2026 Football Analysis Turkish Super League Eyupspor VS Besiktas",
      image: "https://www.zeankickoff1.com/images/logo2/TUR1.jpg"
    },
    {
      title: "26/01/2026 Football Analysis Portuguese Primeira Liga Porto VS Gil Vicente",
      image: "https://www.zeankickoff1.com/images/logo2/Portugal Primeira Liga.jpg"
    },
    {
      title: "26/01/2026 Football Analysis Serie A Italy Verona VS Udinese",
      image: "https://www.zeankickoff1.com/images/logos/italy-r.jpg"
    },
    {
      title: "26/01/2026 Football Analysis Premier League England Everton VS Leeds United",
      image: "https://www.zeankickoff1.com/images/logos/ENGLISH PREMIER new.jpg"
    }
  ];

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 mb-6">
      <h2 className="text-xl font-bold text-white bg-gradient-to-r from-blue-600 to-blue-500 px-4 py-2 rounded mb-4">
        Football Analysis
      </h2>
      <div className="space-y-3">
        {analyses.map((item, index) => (
          <div key={index} className="flex items-center gap-3 hover:bg-gray-50 p-2 rounded cursor-pointer">
            <img 
              src={item.image} 
              alt="League Logo"
              className="w-16 h-16 object-contain flex-shrink-0"
            />
            <h4 className="text-sm font-medium hover:text-blue-600">
              {item.title}
            </h4>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200 text-center space-y-2">
        <a href="#" className="text-blue-600 hover:underline font-semibold block">
          View Past Analysis
        </a>
        <a href="#" className="text-blue-600 hover:underline font-semibold block">
          View Tomorrow's Match Schedule
        </a>
      </div>
    </div>
  );
}